import React, { useState, useEffect } from 'react';

const CatalogForm = (props) => {
    const [ edit, setEdit ] = useState({
        title: true,
        subtitle: true,
        location: true
    });

    useEffect(() => {
        if(props.oldValues.title) {
            setEdit({...edit,title:false, subtitle:false, location: false })
        }
    }, []);

    const onSelectOrigin = (address) => {
        let parsedAddress = JSON.parse(address.target.value);
        props.handleAddressChange(parsedAddress)
    };

    let editView;
    if (props.type === 'edit') {
        editView = (
            <div>
                <label> Sub Judul Anda </label>
                {
                    edit.subtitle ?
                        <div className="form-group input-group-sm ">
                            <input
                                type="text"
                                onChange={props.handleCatalogChange('subtitle')}
                                placeholder="Slogan atau sub judul brand Anda"
                                className="form-control"
                                values={props.newValues.subtitle}
                            />
                        </div>
                        :
                        <div className="d-flex justify-content-between form-group ">
                            <b>
                                {props.oldValues.subtitle}
                            </b>
                            <a onClick={() => setEdit({...edit, subtitle:true})}>
                                <i className="fas fa-edit"></i>
                            </a>
                        </div>
                }
            </div>
        )
    }

    return (
        <form>
            <label> Name Brand </label>
            {
                edit.title ?
                    <div className="form-group input-group-sm ">
                        <input
                            type="text"
                            onChange={props.handleCatalogChange('title')}
                            placeholder="Nama Brand Anda"
                            className="form-control"
                            values={props.newValues.title}
                        />
                    </div>
                    :
                    <div className="d-flex justify-content-between form-group ">
                        <b>
                            {props.oldValues.title}
                        </b>
                        <a onClick={() => setEdit({...edit, title:true})}>
                            <i className="fas fa-edit"></i>
                        </a>
                    </div>
            }
            { editView }
            <div className="form-group input-group-sm">
                <label>Pilih lokasi toko Anda </label>
                { props.addresses.length === 0 ?
                    <input
                        type="text"
                        className="form-control"
                        placeholder={"Harus memasukkan alamat dulu"}
                        disabled
                    />
                    :
                    <div>
                        {
                            edit.location ?
                                <select
                                    id="inputState"
                                    className="form-control"
                                    onChange={address => onSelectOrigin(address)}
                                >
                                    {
                                        props.addresses.map((i,idx) => (
                                            <option
                                                key={idx}
                                                value={JSON.stringify(i)}
                                                className={`${idx === 0 ? "selected":""}`}
                                            >
                                                {i.addressName}
                                            </option>
                                        ))
                                    }
                                </select>
                                :
                                <div className="d-flex justify-content-between form-group ">
                                    <b>
                                        {props.oldValues.addressName}
                                    </b>
                                    <a onClick={() => setEdit({...edit, location:true})}>
                                        <i className="fas fa-edit"></i>
                                    </a>
                                </div>
                        }
                    </div>

                }
                <i>Lokasi ini dapat membantu untuk menghitung biaya kurir ke pelanggan Anda.</i>
            </div>
        </form>
    )
};


export default CatalogForm
